import React, { useEffect } from 'react';
import propTypes from 'prop-types';
;
import { CardContent, Columns, Column, MuiTitle, Subtitle } from 'src/ui/mui-ui-kit';;
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { connect } from 'react-redux';
import { getUser, fetchLoggedInUser } from 'src/user';

const items = [
  'Business Information',
  'Financial Documents',
  'Owner Profiles',
  'Vendors (Payee/Payor)',
  'Product List',
];

const employeeItems = [
  'Home Address',
  'Social Security Number',
  'Date of Birth',
  'Drivers License',
  'Occupation',
];

function StepOverview({ setNextEnabled, user }) {
  useEffect(() => {
    setNextEnabled(true);
  }, []);

  if (
    !user.hasFinishedOnboarding &&
    !user.isMerchantAdmin &&
    !user.isBankAdmin &&
    !user.isSuperAdmin
  ) {
    return (
      <Columns isGapless className="step-overview">
        <Column>
          <CardContent className="content" hasTextColor="grey">
            <MuiTitle
              isSize="3"
              hasTextColor="primary"
              className="has-text-weight-normal"
            >
              Welcome {user.firstName},
            </MuiTitle>
            <p>
              {user.accountName} requires a background check for all employees.
            </p>
            <p>
              Information gathered about you will be used to run a criminal
              history background check.
            </p>
          </CardContent>
        </Column>
        <Column isSize="narrow" className="what-we-need" hasTextColor="white">
          <CardContent>
            <Subtitle isSize="5" hasTextColor="white">
              <span className="icon is-medium">
                <FontAwesomeIcon
                  icon={['fal', 'clipboard-list-check']}
                  size="lg"
                />
              </span>
              <span>What We Need</span>
            </Subtitle>
            <ul>
              {employeeItems.map(item => (
                <li className="item" key={item}>
                  <span className="icon is-medium has-text-grey-medium-dark">
                    <FontAwesomeIcon icon={['fal', 'check-circle']} size="lg" />
                  </span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </CardContent>
        </Column>
      </Columns>
    );
  }
  if (!user.hasFinishedOnboarding && user.isMerchantAdmin) {
    return (
      <Columns isGapless className="step-overview">
        <Column>
          <CardContent className="content" hasTextColor="grey">
            <MuiTitle
              isSize="3"
              hasTextColor="primary"
              className="has-text-weight-normal"
            >
              Welcome {user.accountName},
            </MuiTitle>
            <p>
              We are pleased you have chosen {user.financialInstitutionName}!
              This platform is our Merchant Onboarding Tool that we will use to
              gather all the necessary information needed to provide you our
              suite of banking services.
            </p>
            <p>
              The information gathered will be used to verify that your business
              is operating legally within state and federal guidelines. This
              process takes 1 to 2 hours to complete assuming you have the
              information readily available before starting.
            </p>
          </CardContent>
        </Column>
        <Column isSize="narrow" className="what-we-need" hasTextColor="white">
          <CardContent>
            <Subtitle isSize="5" hasTextColor="white">
              <span className="icon is-medium">
                <FontAwesomeIcon
                  icon={['fal', 'clipboard-list-check']}
                  size="lg"
                />
              </span>
              <span>What We Need</span>
            </Subtitle>
            <ul>
              {items.map(item => (
                <li className="item" key={item}>
                  <span className="icon is-medium has-text-grey-medium-dark">
                    <FontAwesomeIcon icon={['fal', 'check-circle']} size="lg" />
                  </span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </CardContent>
        </Column>
      </Columns>
    );
  }
}

StepOverview.propTypes = {
  user: propTypes.object.isRequired,
  setNextEnabled: propTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    user: getUser(state),
  };
}

const connectedStepOverview = connect(mapStateToProps, {
  fetchLoggedInUser,
})(StepOverview);

export { connectedStepOverview as StepOverview };
